var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "supergroup-list-item",
      class: _vm.itemClass,
      attrs: { id: _vm.supergroup.uuid }
    },
    [
      _c("table", { staticClass: "table table-hover mb-0" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("tbody", [
          _c(
            "tr",
            {
              class: {
                "table-light":
                  (_vm.hasChildren || _vm.hasDomains) && _vm.expanded
              }
            },
            [
              _c(
                "td",
                { staticClass: "align-middle", staticStyle: { width: "40px" } },
                [
                  _vm.hasChildren || _vm.hasDomains
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-outline-secondary",
                          attrs: {
                            title: _vm.expanded ? "Collapse" : "Expand",
                            "aria-expanded": _vm.expanded.toString()
                          },
                          on: { click: _vm.toggleExpand }
                        },
                        [
                          _vm.expanded
                            ? _c("i", { staticClass: "fa fa-minus-square" })
                            : _c("i", { staticClass: "fa fa-plus-square" })
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("td", { staticClass: "align-middle" }, [
                _c("h4", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.supergroup.name) +
                      "\n            "
                  ),
                  (_vm.supergroup.domain_count &&
                    _vm.supergroup.domain_count > 0) ||
                  (_vm.supergroup.child_count && _vm.supergroup.child_count > 0)
                    ? _c("span", { staticClass: "sub-header" }, [
                        _vm._v(" (\n              "),
                        _vm.supergroup.child_count > 0
                          ? _c("span", [
                              _vm._v(
                                "Child Supergroups: " +
                                  _vm._s(_vm.supergroup.child_count)
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.supergroup.child_count > 0 &&
                        _vm.supergroup.domain_count > 0
                          ? _c("span", [_vm._v(" , ")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.supergroup.domain_count > 0
                          ? _c("span", [
                              _vm._v(
                                "Child Domains: " +
                                  _vm._s(_vm.supergroup.domain_count)
                              )
                            ])
                          : _vm._e(),
                        _vm._v("\n            )\n            ")
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-sm btn-outline-info me-2",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("select", _vm.supergroup)
                      }
                    }
                  },
                  [_vm._v("\n            View Users\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-primary me-2",
                    attrs: {
                      title: "Edit",
                      disabled: !_vm.canManageSupergroups
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("edit", _vm.supergroup)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-pencil" }),
                    _vm._v(" Edit\n          ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-danger",
                    attrs: {
                      title: "Delete",
                      disabled: !_vm.canManageSupergroups
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("delete", _vm.supergroup)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(" Delete\n          ")
                  ]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.expanded
        ? _c("div", { staticClass: "nested-content" }, [
            _vm.hasChildren
              ? _c(
                  "div",
                  { staticClass: "nested-items" },
                  _vm._l(_vm.children, function(child) {
                    return _c("SupergroupListItem", {
                      key: child.uuid,
                      ref: "supergroupListItems",
                      refInFor: true,
                      attrs: {
                        supergroup: child,
                        "all-supergroups": _vm.allSupergroups,
                        canManageSupergroups: _vm.canManageSupergroups
                      },
                      on: {
                        edit: function($event) {
                          return _vm.$emit("edit", $event)
                        },
                        delete: function($event) {
                          return _vm.$emit("delete", $event)
                        },
                        select: function($event) {
                          return _vm.$emit("select", $event)
                        }
                      }
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasDomains
              ? _c("div", { staticClass: "domains-section mt-2" }, [
                  _c("h5", { staticClass: "domains-header" }, [
                    _vm._v("Associated Domains")
                  ]),
                  _vm._v(" "),
                  _vm.loadingDomains
                    ? _c("div", { staticClass: "text-center py-2" }, [
                        _vm._m(1)
                      ])
                    : _vm.domainError
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger py-1 px-2",
                          attrs: { role: "alert" }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-exclamation-triangle me-1"
                          }),
                          _vm._v(
                            "\n        " + _vm._s(_vm.domainError) + "\n      "
                          )
                        ]
                      )
                    : _c(
                        "table",
                        { staticClass: "table table-sm domains-table" },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.domains, function(domain) {
                              return _c("tr", { key: domain.domain_uuid }, [
                                _c("td", [_vm._v(_vm._s(domain.name))]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "#!/domains/" + domain.domain_uuid
                                      }
                                    },
                                    [_vm._v(_vm._s(domain.domain_uuid))]
                                  )
                                ])
                              ])
                            }),
                            0
                          )
                        ]
                      )
                ])
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "visually-hidden" }, [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Expand/Collapse")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Supergroup Name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Actions")])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border spinner-border-sm text-primary" },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Loading domains...")
        ])
      ]
    )
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("UUID")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }